// @ts-nocheck
import { ReactElement } from "react";
import { ToastContainer as ToastifyContainer, Slide } from "react-toastify";

import "react-toastify/dist/ReactToastify.min.css";

export interface ToastContainerProps {
  rtl?: boolean;
  autoClose?: number;
  pauseOnHover?: boolean;
}

const ToastContainer = ({
  rtl = false,
  autoClose = 3000,
  pauseOnHover = false,
}: ToastContainerProps): ReactElement => {
  return (
    <ToastifyContainer
      autoClose={autoClose}
      closeOnClick={false}
      draggable={false}
      hideProgressBar={true}
      newestOnTop={true}
      pauseOnHover={pauseOnHover}
      pauseOnFocusLoss={false}
      position={rtl ? "top-left" : "top-right"}
      rtl={rtl}
      transition={Slide}
    />
  );
};

export default ToastContainer;
